import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Partner } from '../../interfaces/partners.interface';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-partnerspartner-view',
  standalone: false,
  templateUrl: './partnerspartner-view.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./partnerspartner-view.component.scss']
})
export class PartnerspartnerViewComponent {
  @Input() partner?: Partner;
  imagesUrl = `${environment.ImagesUrl}/partners/`;
}
